import { FC } from "react";
import ConfirmationModal from "@/components/modal/confirmation";
import useCashRegisterStore from "@/stores/cash-register";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";
import { Routes } from "@/types/routes";
import { useAppSelector } from "@/hooks/useAppSelector";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { acceptAgecheck, denyAgeCheck } from "@/store/cart/thunk";
import { selectRequiredAge } from "@/store/cart/selectors";

const AgeCheckModal: FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const requiredAge = useAppSelector(selectRequiredAge);
  const { current: currentCashRegister } = useCashRegisterStore();
  const shouldVerifyAge = !!currentCashRegister?.shop.property.validateLegalAge;

  if (!requiredAge) return null;
  if (shouldVerifyAge && requiredAge) return <Navigate to={Routes.AGE_VERIFICATION_PAGE} />;

  const onAccept = () => {
    dispatch(acceptAgecheck(requiredAge));
  };

  const onDeny = () => {
    dispatch(denyAgeCheck());
  };

  return (
    <ConfirmationModal
      visible
      title={t("mainPage.ageCheckModal.title", { age: requiredAge })}
      message={t("mainPage.ageCheckModal.message", { age: requiredAge })}
      confirmText={t("mainPage.ageCheckModal.confirmText", { age: requiredAge })}
      cancelText={t("mainPage.ageCheckModal.cancelText")}
      onConfirm={onAccept}
      onCancel={onDeny}
      testId="age-check"
    />
  );
};

export default AgeCheckModal;
